'use strict';

/* global $ */

import { breakpoints } from '../settings'

function header(options) {

    let opt = $.extend({
        selector: '.js-header',
        menuSelector: '.js-header-menu',
        stickMenuSelector:'.js-stick-menu',
        stickSelector: '.js-stick-hamburger',
        stickLink:'.js-stick-link',
        hamburgerSelector: '.js-header-hamburger',
        linkSelector: '.js-header-link',
        stickClose: '.js-stick-close'
    }, options);

    let $window = $(window);

    function initBlock(el) {
        let $header = $(el),
            $menu = $header.find(opt.menuSelector),
            $burger = $header.find(opt.hamburgerSelector),
            link = $header.find(opt.linkSelector);


        let isActive = false,
            StickisActive = false;

        let windowWidth;

        for (let i = link.length ; i >= 0; i--) {
            link.eq(i).css({transition: '0.'+link.length-i*0.1+0.2+'s ease-in'});
        }

        function show() {
            $menu.addClass('is-active');
            $burger.addClass('is-active');
            link.addClass('is-active');
            isActive = true;
            $('.body').css('overflow-y','hidden');
        }

        function hide() {
            $menu.removeClass('is-active');
            $burger.removeClass('is-active');
            link.removeClass('is-active');
            isActive = false;
            $('.body').css('overflow-y','auto');   
        }

        function showStick() {
            stickscroll();
            stickMenu.addClass('is-active');
            stickBurg.addClass('is-active');
            stickLink.addClass('is-active');
            stickClose.addClass('is-active');
            StickisActive = true;
        }

        function hideStick() {
            //stickscroll();
            stickMenu.removeClass('is-active');
            stickBurg.removeClass('is-active');
            stickLink.removeClass('is-active');
            stickClose.removeClass('is-active');
            StickisActive = false;   
        }

        $burger.on('click', function(e) {
            e.preventDefault();
            if (!isActive) {
                show();
                logo();
            } else {
                hide();
                logo();
            }
        });

        function logo(){
            let logo = $('.js-logo');
            if (isActive||StickisActive) {
                logo.css('position','fixed');
            }
            else{
                logo.css('position','initial');
            }
        }

        function stick(){

            $menu.clone().insertAfter('.header__stick').addClass('cloned')
            .removeClass('js-header-menu').addClass('js-stick-menu')
            .find(opt.linkSelector).removeClass( 'js-header-link' ).addClass( 'js-stick-link');

        }

        function stickscroll(){
            let windowWidth = $window.width();
            let stick = $('.js-stick');
            if (windowWidth < breakpoints.s && !isActive && !StickisActive) {
                let headH = $header.height();
                var pageY = window.pageYOffset || document.documentElement.scrollTop;

                if (pageY > headH && !StickisActive){
                    stick.css('transform','translate(0)');
                }
                else {
                    stick.eq(0).css('transform','translate(-100%)');
                    stick.eq(1).css('transform','translate(100%)');
                }
            } else {

                stick.eq(0).css('transform','translate(-100%)');
                stick.eq(1).css('transform','translate(100%)');
            }


        }

        function resizeWindow() {
            windowWidth = $window.width();
            
            if (windowWidth > breakpoints.s) {
                if (isActive || StickisActive) {
                    $('.js-logo').css({position:'initial'});
                    hide();
                    hideStick();
                }
            }
        }

        $window.on('scroll', stickscroll);

        $window.on('resize', function(){ resizeWindow(), logo()});
        resizeWindow();
        stick();
        stickscroll();
        let stickBurg = $(opt.stickSelector),
            stickMenu = $(opt.stickMenuSelector),
            stickClose = $(opt.stickClose),
            stickLink = $(opt.stickLink);

        stickBurg.on('click', function(e) {
            e.preventDefault();
            if (!StickisActive) {
                showStick();
                logo();
                stickscroll();
            } else {
                stickscroll();
                hideStick();
                logo();
            }
        });

        stickClose.on('click', function(e) {
            e.preventDefault();
            if (!StickisActive) {
                showStick();
                logo();
                stickscroll();
            } else {
                hideStick();
                logo();
                stickscroll();
            }
        });
    }

    function stickHeader(item) {
        // Create a clone of the menu, right next to original.
        $(item).addClass('original').clone().insertAfter(item).addClass('cloned').removeClass('js-header')
        .css('position','fixed').css('top','0').css('margin-top','0').addClass('stick-header')
        .css('z-index','500').css('background-image','linear-gradient(110deg,#039,#004ce6)')
        .removeClass('original').hide();

        let stickHeaderItem = $('.stick-header');
        let productImageBlock = $('.js-images-block');
        let productImageBlockOffsetTop = 0;
        if (productImageBlock.length > 0) {
            productImageBlockOffsetTop = productImageBlock.offset().top;
        }

        $window.on('scroll', stickIt);

        function stickIt() {

            //let orgElementPos = $('.original').offset();
            //let orgElementTop = orgElementPos.top;
            let orgElementTop = $(item).height();
            let stickHeaderHeight = $(stickHeaderItem).height();
            let pageY = window.pageYOffset || document.documentElement.scrollTop;

            let headerMargin = (orgElementTop - stickHeaderHeight) * 0.5;

            if (pageY > headerMargin && $(window).width() > breakpoints.s) {

                $(stickHeaderItem).css('top',0).show(0).addClass('active');
                $(item).css('visibility','hidden');

                if (productImageBlock.length > 0) {
                    let productHeaderMargin = (productImageBlockOffsetTop - stickHeaderHeight - 32);
                    let stickhead = pageY - stickHeaderHeight - 32;

                    if ($(stickHeaderItem).is(':hidden') || pageY < productHeaderMargin){
                        stickhead = 0;
                    } else if (stickhead > stickHeaderHeight) {
                        stickhead = stickHeaderHeight;
                    }
                    productImageBlock.css('margin-top', stickhead).css('transition', '0.2s ease-in-out');
                }

            } else {

                $(stickHeaderItem).hide().removeClass('active');
                $(item).css('visibility', 'visible');
                productImageBlock.css('margin-top', 0);
            }
        }
    }

    $(opt.selector).each(function() {
        initBlock(this);
        stickHeader(this);
    });


}

export {
    header
};